import styled, { css } from 'styled-components';

export const EvoTransportContainer = styled.div<{ $isOutBound?: boolean }>`
  width: 100%;
  position: relative;

  @media (min-width: 768px) {
    width: 50%;
  }

  ${({ $isOutBound }) =>
    $isOutBound
      ? css`
          margin-bottom: 12px;

          @media (min-width: 768px) {
            margin-bottom: 0px;
            padding-right: 24px;
            padding-bottom: unset;
          }
        `
      : css`
          margin-top: 12px;

          @media (min-width: 768px) {
            margin-top: 0px;
            padding-left: 24px;
            padding-top: unset;
          }
        `}
`;
